const sectionsNames = {
  VIDEO: 'VIDEO',
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  QUOTE: 'QUOTE',
  CALL_TO_ACTION_FULLWIDTH: 'CALL_TO_ACTION_FULLWIDTH',
  TOP_THREE_TIPS: 'TOP_THREE_TIPS',
  HELPFUL_GUIDES: 'HELPFUL_GUIDES',
  CDF: 'CDF',
  CALCULATOR: 'CALCULATOR',
  REVIEWIO: 'REVIEWIO',
  REVIEWS: 'REVIEWS',
  QUESTIONS_ANSWERS: 'QUESTIONS_ANSWERS',
  CTA_BUTTON: 'CTA_BUTTON',
  BANNER: 'BANNER',
  FULLWIDTHREVIEW: 'FULLWIDTHREVIEW',
  PRICE: 'PRICE',
  REPRESENTATION: 'REPRESENTATION',
  ABOUT: 'ABOUT',
  CLIENT: 'CLIENT',
  LAWYER: 'LAWYER',
  TOOLS: 'TOOLS',
  FAQ: 'FAQ',
  FEESBANNER: 'FEESBANNER',
  FEESPROCESS: 'FEESPROCESS',
  FEESCALCULATE: 'FEESCALCULATE',
  AWARD: 'AWARD',
  TACTICS: 'TACTICS',
  TACTICSBANNER: 'TACTICSBANNER',
  AUTOSCHEDULE: 'AUTOSCHEDULE',
  BLOG: 'BLOG',
};

export default sectionsNames;
